import dayjs from 'dayjs';
import { getEnumValuesAsArray } from 'utils/enum';
import { randomBoolean, randomDate, randomInteger, randomUUID, randomWords } from 'utils/random';
import { ForecastType } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/forecast.type';
import {
  Recommendation,
  RecommendationAssortment,
  RecommendationProduct,
} from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/types/recommendation-assortment.type';
import { formatDate } from 'views/order-feed/features/my-supply-plan/utils/order-utils';
import { DispatchScheduleWithScheduleData } from 'views/order-feed/mock/dispatch-schedule-data.mock';
import CustomerAssortmentData from 'views/order-feed/mock/customer-assortment-data.mock';

export const generateRecommendationType = () =>
  getEnumValuesAsArray(ForecastType)[Math.floor(Math.random() * getEnumValuesAsArray(ForecastType).length)] as ForecastType;

const randomSchedule = () =>
  DispatchScheduleWithScheduleData.dispatchDateData[
    Math.floor(Math.random() * DispatchScheduleWithScheduleData.dispatchDateData.length)
  ];

//TODO: This should be recommendations (Known as Forecasts)
const generateRecommendation = (): Recommendation => {
  const products = randomRecommendationProducts();
  const productsOutsideCustomerAssortment = products.reduce((acc: string[], product) => {
    if (Math.random() < 0.5) {
      acc.push(product.name);
    }
    return acc;
  }, []);

  const schedule = randomSchedule();

  return {
    dispatch: schedule.dispatchDate,
    plantId: schedule.factoryId,
    vessel: schedule.vessel,
    delivery: schedule.estimatedArrivalDate || formatDate(dayjs(schedule.dispatchDate).add(2, 'days').toISOString()),
    autoSkipped: randomBoolean(),
    manuallySkipped: randomBoolean(),
    products,
    productsOutsideCustomerAssortment,
    autoConfirmDate: randomDate(2),
    autoConfirmInDays: randomInteger(10),
    minimumDaysBeforeNewOrderDispatch: 10,
    plantName: 'Bergneset'
  };
};

//Returns an array of 3 random products from the available products in CustomerAssortment mock data.
const randomRecommendationProducts = () => {
  const products = [];
  const availableProducts = CustomerAssortmentData.availableProducts;
  const usedProductIndexes = new Set();

  for (let i = 0; i < 3; i++) {
    let productIndex;
    do {
      productIndex = randomInteger(availableProducts.length - 1);
    } while (usedProductIndexes.has(productIndex));

    usedProductIndexes.add(productIndex);

    const product = availableProducts[productIndex];
    products.push({
      ...product,
      productNumber: product.itemNumber,
      name: product.itemName,
      quantity: randomInteger(20000),
    });
  }

  return products;
};

const generateRecommendationProducts = (count: number = 3) => {
  const array: RecommendationProduct[] = [];
  for (let index = 0; index < count; index++) {
    array.push(generateRecommendedProduct());
  }
  return array;
};

const generateRecommendedProduct = (): RecommendationProduct => {
  return {
    quantity: randomInteger(300000),
    name: randomWords(3, 20),
    productNumber: randomUUID(),
  };
};

const generateRecommendationAssortment = (count: number = 5): RecommendationAssortment => {
  const recommendations: Recommendation[] = [];
  for (let index = 0; index < count; index++) {
    recommendations.push(generateRecommendation());
  }
  return {
    scheduleTooShort: randomBoolean(),
    globalSiteId: randomUUID(),
    recommendations,
    productsUnavailableAtPlant: [],
  };
};

export const RecommendationAssortmentData: RecommendationAssortment = generateRecommendationAssortment();
